<!-- rendering from templates -->
<div class="panel-content" [innerHtml]="html"></div>
<!-- rendering from templates end -->

<div class="add-features-toggle">
  <span>Add features</span>
  <div class="material-switch pull-right">
    <mat-slide-toggle
      color="primary"
      #newFeature
      id="newFeature"
      type="checkbox"
      [checked]="saveNewFeature"
      (change)="newFeacture(newFeature.checked)"
    ></mat-slide-toggle>
  </div>

</div>
<span class="hint"></span>
<div class="panel-text-others">Choose a layer below then click in the map to add a new feature.</div>
<div class="accordion">
  <ng-container *ngFor="let key of objectKeys(refineLayersData); let i = index">
    <h3
      [ngClass]="togglePanel[i] === true ? 'current' : ''"
      id="head-WaterInfrastructure"
      (click)="togglePanel[i] = !togglePanel[i]; toggleClass(key)"
      class="layers-head mytooltip _tooltip op"
    >
      {{ key
      }}<span
        id="basemap_tooltip"
        class="tooltiptext"
        style="visibility: hidden; opacity: 0"
      ></span>
    </h3>
    <ng-container *ngIf="togglePanel[i]">
      <ng-container
        *ngFor="let key1 of objectKeys(refineLayersData[key]); let i = index"
      >
        <ng-container *ngIf="key1 === 'layers'">
          <ul
            id="WaterInfrastructure"
            *ngFor="let data of refineLayersData[key][key1]; let i = index"
          >
            <li
              zoom="6"
              class="overlay-li"
              #current
              id="current"
              (click)="getLayerData(data, data.id)"
              [ngClass]="captureService.clickedIndex === data.id ? 'current' : ''"
            >
              <span
                class="legend-icon"
                [ngStyle]="{
                  'background-image': 'url(' + data.legend.icon + ')'
                }"
              ></span
              ><label
                ><p
                  data-name="Blowoff"
                  class="legend-name"
                  [tooltip]="capturelayersToolTip"
                  [options]="myOptions2"
                >
                  {{ data.name }}
                </p>
              </label>
            </li>
          </ul>
        </ng-container>
        <ng-container *ngIf="key1 !== 'layers'"> </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<div class="buttonDiv">
  <a class="closer closerToolTip">
    <img
      (click)="closeLeft()"
      class="closer-img common-btns tool-toolTip"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
    /><span class="tooltiptext tip-bottom"
      ><strong>Close</strong>
      <p>Close panel</p></span
    >
  </a>
</div>
